module.exports = __webpack_public_path__ + "static/media/Home.7cf24f7d.svg";